import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FaturasComponent } from './faturas/faturas.component';
import { MsalGuard } from '@azure/msal-angular';

const routes: Routes = [
  { path: '',   redirectTo: '/faturas', pathMatch: 'full' },
  { path: 'faturas', component: FaturasComponent, canActivate: [MsalGuard] }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{
    useHash: true,
    relativeLinkResolution: 'legacy'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
